import React from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser, hasPermission } from "../core/utils/auth";

/**
 * Route Guard for Granular Feature Permissions:
 * Checks if current user has permission to access the route.
 * SuperAdmin and Admin always pass.
 * If permission check fails, redirects user to home/dashboard ("/").
 */
export default function PermissionRoute({ permission, children }) {
  const user = getCurrentUser();

  if (!hasPermission(user, permission)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

